// Utility function to generate slug from name
export const generateSlug = (name) => {
    return name
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/(^-|-$)/g, '');
};

// Utility function to get solution by slug
export const getSolutionBySlug = (solutions, slug) => {
    return solutions.find(s => generateSlug(s.name) === slug);
};

